// extracted by mini-css-extract-plugin
module.exports = {"confirmationNumber":"thank_panel_confirmationNumber__2pErx","container":"thank_panel_container__1v9qC","panel":"thank_panel_panel__VqGDk"};